export default __webpack_public_path__ + "static/media/rightLightAnchor.c0175267.svg";